import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { GetUnitPriceFrequencies } from '@/graphql/contracts/_generated_/getUnitPriceFrequencies.query';
import GetUnitPriceFrequenciesQuery from '@/graphql/contracts/getUnitPriceFrequencies.query.gql';

export function getUnitPriceFriquencies(): UnitPriceFrequency[] {
  const result = apolloClientContracts.readQuery<GetUnitPriceFrequencies>({
    query: GetUnitPriceFrequenciesQuery
  });

  return result?.unitPriceFrequencies || [];
}
